<template>
    <div v-wechat-title="title">
        <crud-facecade-pag
            ref="records-list"
            :url="url"
            :columns="columnList"
            :buttons="[]"
            :tableHeight="screenHeight - 200"
            :addButton="{ enabled: false, permission: 'default' }"
            :updateButton="{ enabled: false, permission: 'default' }"
            @uploadRecord="uploadRecord"
            @selectionChange="loadChecked"
            :showSequence="false"
            :selection="true"
            :reserveSelection="true"
            :filterSpan="[13, 8, 0, 0, 4, 1]"
        >
            <slot slot="filter">
                <el-col :span="8">
                    <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
                </el-col>
                <el-col :md="5">
                    <item-input type="select" v-model="dic_operating_ward_id" :options="operation_ward_auth" :clearable="true" placeholder="请选择区域"></item-input>
                </el-col>
            </slot>
            <template slot="filter-after">
                <el-button type="primary" size="mini" @click="ReloadListData">刷新<i class="el-icon--right"></i></el-button>
                <el-button type="primary" size="mini" @click="uploadChecked" v-show="this.permissions && this.permissions.findIndex(item => item.permission === `cda_records:batch_upload`) != -1"
                    >批量上传<i class="el-icon--right"></i
                ></el-button>
                <el-button type="primary" size="mini" @click="batchDeleteRecords" v-show="this.permissions && this.permissions.findIndex(item => item.permission === `cda_records:batch_delete`) != -1"
                    >批量删除<i class="el-icon--right"></i
                ></el-button>
                <el-button type="primary" size="mini" @click="clearAllRecords" v-show="this.permissions && this.permissions.findIndex(item => item.permission === `cda_records:clear_all`) != -1"
                    >一键清空<i class="el-icon--right"></i
                ></el-button>
            </template>
            <template slot="patient_info" slot-scope="{ row }">
                <el-row>
                    <el-col :span="1" class="height-p100">
                        <div
                            class="surgery-status-tag"
                            style="height: 60px"
                            :class="row.enum_surgery_status == 30 ? 'bg-danger' : row.enum_surgery_status == 20 || row.enum_surgery_status == 10 ? 'bg-primary' : 'bg-info'"
                        >
                            &nbsp;<br />&nbsp;<br />&nbsp;
                        </div>
                    </el-col>
                    <el-col :span="23" class="padding5 padding-none-v align-left">
                        <div class="ellipsis" :title="`${row.patient_name}(${row.sex || '--'}/${row.age || '--'}/${row.visit_no}/${row.bed_no || '--'}床)`">
                            <b>
                                {{ `${row.patient_name}(${row.sex || '--'}/${row.age || '--'}/${row.visit_no}/${row.bed_no || '--'}床)` }}
                                <el-tag :type="row.surgery_info.enum_surgery_type == 1 ? 'danger' : 'primary'" size="mini" v-if="row.surgery_info.enum_surgery_type">{{
                                    row.surgery_info.surgery_type
                                }}</el-tag>
                                <span class="circle fg-red borderd" v-if="row.surgery_info.is_reoperation">再</span>
                            </b>
                        </div>
                        <div>
                            <b class="ellipsis">{{ row.surgeries }}</b>
                        </div>
                    </el-col>
                </el-row>
            </template>
            <template slot="orign_file_path" slot-scope="{ row }">
                <i v-show="row.orign_file_path" class="el-icon-view" :title="row.orign_file_path" style="font-size: 25px; cursor: pointer" @click="loadXML(row.orign_file_path)"></i>
            </template>
            <template slot="req_file_path" slot-scope="{ row }">
                <i v-show="row.req_file_path" class="el-icon-view" :title="row.req_file_path" style="font-size: 25px; cursor: pointer" @click="loadXML(row.req_file_path)"></i>
            </template>
            <template slot="resp_file_path" slot-scope="{ row }">
                <i v-show="row.resp_file_path" class="el-icon-view" :title="row.resp_file_path" style="font-size: 25px; cursor: pointer" @click="loadXML(row.resp_file_path)"></i>
            </template>
            <template slot="flag" slot-scope="{ row }">
                <span v-if="row.flag == 0">未上传</span>
                <span v-if="row.flag == 1" style="color: #66cd00">上传成功</span>
                <span v-if="row.flag == 2" style="color: red">上传失败</span>
            </template>
        </crud-facecade-pag>
        <el-dialog id="cda" title="xml详情" :visible.sync="XMLVisible" :key="XMLVisible" width="80%" @close="closeDialog">
            <div :style="{ height: `${this.screenHeight - 100}px` }">
                <pre v-highlight :style="{ height: `${this.screenHeight - 110}px`, overflow: `auto` }">
                    <code style="text-align: left;">{{xmlList}}</code>
                </pre>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import hljs from 'highlight.js'
// 样式文件，可选择node_modules-highlight.js-styles文件夹里其他高亮样式css
import 'highlight.js/styles/atom-one-dark.css'

export default {
    name: `CDARecord`,
    data() {
        return {
            title: `互联互通`,
            rdate: this.loadDefaultValue(),
            url: {
                baseURL: `/api/Operation/CDARecord`,
                get: paras => {
                    return new Promise(resolve => {
                        this.ReloadData().then(data => {
                            resolve(data)
                        })
                    })
                }
            },
            recordsList: [],
            checkedRow: [],
            o_dic_operating_ward_id: undefined,
            issetoperatingward: false,
            XMLVisible: false,
            xmlList: null,
            uploadStatus: [
                { label: `未上传`, value: 0 },
                { label: `上传成功`, value: 1 },
                { label: `上传失败`, value: 2 }
            ]
        }
    },
    created() { },
    directives: {
        'highlight': {
            bind: function(el, binding) {
                let blocks = el.querySelectorAll(`code`)
                blocks.forEach((block) => {
                    hljs.highlightBlock(block)
                })
            }
        }
    },
    computed: {
        ...mapGetters([`sys_enums`, `ward_auth`, `active_ward`, `operation_ward_auth`, `screenHeight`, `permissions`]),
        tableHeight() {
            return (this.screenHeight && this.screenHeight - 190) || 0
        },
        dic_operating_ward_id: {
            get: function() {
                let wardid = sessionStorage.getItem(`cda_operating_ward_id`)
                if (!this.issetoperatingward && wardid) {
                    this.o_dic_operating_ward_id = wardid
                } else if (!this.issetoperatingward && this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                    this.o_dic_operating_ward_id = this.active_ward.origion
                }
                return this.o_dic_operating_ward_id
            },
            set: function(v) {
                this.o_dic_operating_ward_id = v
                this.issetoperatingward = true
            }
        },
        columnList() {
            let me = this
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `number`,
                    prop: `row_index`,
                    label: `序号`,
                    width: `50`,
                    isListable: true
                },
                {
                    type: `custom`,
                    prop: `patient_info`,
                    label: `患者信息卡`,
                    width: `360`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `patient_name`,
                    label: `患者姓名`,
                    isListable: false,
                    searchable: true
                },
                {
                    type: `string`,
                    prop: `patient_abbr`,
                    label: `患者姓名简拼`,
                    isListable: false,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `visit_no`,
                    label: `住院号`,
                    isListable: false,
                    searchable: true
                },
                {
                    type: `string`,
                    prop: `surgeries`,
                    label: `手术方式`,
                    isListable: false,
                    queryable: true
                },
                {
                    type: `select`,
                    prop: `enum_doc_type`,
                    label: `文书类型`,
                    width: `200`,
                    options: this.sys_enums.Enum_DocType || [],
                    isListable: true,
                    searchable: true
                },
                {
                    type: `string`,
                    prop: `last_upload_by_name`,
                    label: `操作人`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `last_upload_time`,
                    label: `上传时间`,
                    width: `150`,
                    isListable: true
                },
                {
                    type: `custom`,
                    prop: `flag`,
                    label: `上传状态`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `flag`,
                    label: `上传状态`,
                    width: `100`,
                    options: this.uploadStatus,
                    searchable: true
                },
                {
                    type: `string`,
                    prop: `remark`,
                    label: `备注`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `custom`,
                    prop: `orign_file_path`,
                    label: `原始文档`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `custom`,
                    prop: `req_file_path`,
                    label: `请求内容`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `custom`,
                    prop: `resp_file_path`,
                    label: `响应内容`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    fixed: `right`,
                    label: `操作`,
                    width: `150`,
                    isListable: true,
                    options: function(that, { row }) {
                        if (row.flag == 0 && me.permissions && me.permissions.findIndex(item => item.permission === `cda_records:upload`) != -1) {
                            return [
                                {
                                    class: `is-plain`,
                                    label: `上传`,
                                    icon: ``,
                                    type: `primary`,
                                    emit: `uploadRecord`,
                                    permission: `default`
                                }
                            ]
                        } else if (row.flag == 2 && me.permissions && me.permissions.findIndex(item => item.permission === `cda_records:re_upload`) != -1) {
                            return [
                                {
                                    class: `is-plain`,
                                    label: `重新上传`,
                                    icon: ``,
                                    type: `danger`,
                                    emit: `uploadRecord`,
                                    permission: `default`
                                }
                            ]
                        }
                    }
                }
            ]
        }
    },
    methods: {
        loadDefaultValue() {
            return [
                this.$moment()
                    .add(0, `days`)
                    .format(`YYYY-MM-DD`),
                this.$moment()
                    .add(0, `days`)
                    .format(`YYYY-MM-DD`)
            ]
        },
        ReloadListData() {
            if (this.$refs[`records-list`]) {
                this.$refs[`records-list`].ReloadListData()
            }
        },
        ReloadData() {
            let that = this
            that.checkedRow = []
            return new Promise(resolve => {
                let req = that.myaxios.get(`/api/Operation/CDARecord/GetCDARecords`, { begin: that.rdate[0], end: that.rdate[1] })
                req.then(data => {
                    if (that.dic_operating_ward_id) {
                        data = _.filter(data, { dic_operating_ward_id: parseInt(that.dic_operating_ward_id) })
                    }
                    that.recordsList = data
                    console.log(that.recordsList)
                    resolve(data)
                }).catch(e => {
                    resolve([])
                })
            })
        },
        loadChecked({ row }) {
            this.checkedRow = row
            console.log(row)
        },
        uploadRecord({ row, index }) {
            let that = this
            if (row.id > 0 && row.flag != 1) {
                let ids = []
                ids.push(row.id)
                that.uploadRecords(ids)
            }
        },
        uploadChecked() {
            let that = this
            let selectRows = _.filter(that.checkedRow, d => {
                return d.id > 0 && d.flag != 1
            })
            if (!selectRows || selectRows.length <= 0) {
                let msg = that.checkedRow.length > 0 ? `（已上传的无需重复上传）` : ``
                that.$message.error(`请选择要上传数据！${msg}`)
            } else {
                let ids = _.map(selectRows, d => d.id)
                that.uploadRecords(ids)
            }
        },
        uploadRecords(ids) {
            let that = this
            let req = that.myaxios.put(`/api/Operation/CDARecord/UploadRecords`, ids)
            req.then(data => {
                console.log(data)
                that.$message.success(`上传成功`)
                that.$refs[`records-list`].ReloadListData()
            }).catch(e => {
                that.$message.error(`上传失败`)
                console.log(e)
            })
        },
        batchDeleteRecords() {
            let that = this
            let selectRows = _.filter(that.checkedRow, d => {
                return d.id > 0
            })
            if (!selectRows || selectRows.length <= 0) {
                that.$message.error(`请选择要删除数据！`)
                return
            }
            this.$confirm(`是否确认删除?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            })
                .then(() => {
                    let ids = _.map(selectRows, d => d.id)
                    let req = that.myaxios.put(`/api/Operation/CDARecord/BatchDeleteRecords`, ids)
                    req.then(data => {
                        that.$message.success(`删除成功`)
                        that.$refs[`records-list`].ReloadListData()
                    }).catch(e => {
                        that.$message.error(`删除异常,请尝试刷新后重新删除`)
                        console.log(e)
                    })
                })
                .catch(e => {
                    console.log(e)
                })
        },
        clearAllRecords() {
            let that = this
            // 确认清空时间段
            this.$confirm(`是否确认是否清空${that.rdate[0]}至${that.rdate[1]}数据?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            })
                .then(() => {
                    let req = that.myaxios.put(`/api/Operation/CDARecord/ClearAllRecords?begin=${that.rdate[0]}&end=${that.rdate[1]}`)
                    req.then(() => {
                        that.$message.success(`一键清空成功`)
                        that.$refs[`records-list`].ReloadListData()
                    }).catch(e => that.$message.error(`一键清空失败`))
                })
                .catch(e => {
                    console.log(e)
                })
        },
        loadXML(path) {
            let that = this
            let req = that.myaxios.get(`/api/Operation/CDARecord/GetXMLFile?path=${path}`)
            req.then(data => {
                that.xmlList = that.vkbeautify.xml(data)
                that.XMLVisible = true
            }).catch(e => {
                console.log(e)
            })
            console.log(path)
        },
        // 关闭弹框的事件
        closeDialog() {
            let that = this
            that.xmlList = ``
            that.XMLVisible = false
        }
    },
    beforeDestroy() {
        // 离开页面暂存页面已设置内容，方便下次进入 记忆功能
        sessionStorage.setItem(`cda_operating_ward_id`, this.dic_operating_ward_id)
    },
    watch: {
        rdate: function() {
            this.$refs[`records-list`].ReloadListData()
        },
        dic_operating_ward_id: function(newVlaue, oldValue) {
            this.$refs[`records-list`].ReloadListData()
        }
    }
}
</script>

<style lang="less">
.iconButton {
    border: none;
    font-size: 25px;
}
.hljs {
    color: #bebebe !important;
    background: none !important;
}
pre code.hljs {
    overflow-x: visible !important;
    display: block !important;
    padding: 0px !important;
}
#cda .el-dialog__body {
    padding: 0px 0px 0 10px !important;
    background: #282c34 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/CDARecord/Index.vue